module.exports = __webpack_public_path__ + "img/laptop.28707f69.png";